import React, { createContext, useContext, useEffect, useMemo, useState } from 'react';
import AuthService from '../services/AuthService';
import { clearSession, clearToken, getSession, getToken, setSession, setToken } from '../utils/session';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => getSession());
    const [ready, setReady] = useState(false);

    useEffect(() => {
        const token = getToken();
        if (!token) {
            setReady(true);
            return;
        }
        AuthService.me()
            .then((activeUser) => {
                setSession(activeUser);
                setUser(activeUser);
            })
            .catch(() => {
                clearSession();
                clearToken();
                setUser(null);
            })
            .finally(() => setReady(true));
    }, []);

    const value = useMemo(() => ({
        user,
        ready,
        login: async (credentials) => {
            const data = await AuthService.login(credentials);
            setToken(data.token);
            setSession(data.user);
            setUser(data.user);
            return data.user;
        },
        logout: () => {
            clearToken();
            clearSession();
            setUser(null);
        },
    }), [user, ready]);

    return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
